import React, {useState, useEffect} from 'react';
import {getAllPokemon, getPokemon} from './services/pokemon';
import Card from '../src/components/CardComponent/Card';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {

  const [pokemonData, setPokemonData] = useState([]);
  const [nextUrl, setNextUrl] = useState("");
  const [prevUrl, setPrevUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const initialUrl = "https://pokeapi.co/api/v2/pokemon/";

  useEffect(() => {
    async function fetchData() {
      let response = await getAllPokemon(initialUrl);
      setNextUrl(response.next);
      setPrevUrl(response.previous);
      await loadPokemon(response.results);
      setLoading(false);
      // console.log(response);
    }
    fetchData();
  }, []);

  const next = async () => {
    setLoading(true);
    let data = await getAllPokemon(nextUrl);
    await loadPokemon(data.results);
    setNextUrl(data.next);
    setPrevUrl(data.previous);
    setLoading(false);
  }

  const prev = async () => {
    if(!prevUrl) return;
    setLoading(true);
    let data = await getAllPokemon(prevUrl);
    await loadPokemon(data.results);
    setNextUrl(data.next);
    setPrevUrl(data.previous);
    setLoading(false);
  }

  const loadPokemon = async (data) => {
    let _pokemonData = await Promise.all(
      data.map(async pokemon => {
        let pokemonRecord = await getPokemon(pokemon.url)
        return pokemonRecord
      })
    )
    setPokemonData(_pokemonData);
  }

  return (
    <div>      
        {loading ? <h2 style={{textAlign: 'center'}}>Loading...</h2> : (
      <>
      <Navbar />
      <div className="btn">
        <button onClick={prev}>Prev</button>
        <button onClick={next}>Next</button>
      </div>
      <div className="grid-container">
        {
          pokemonData.map((pokemon, i) => {
            return <Card key={i} pokemon={pokemon} />
          })
        }
      </div>
      <div className="btn">
        <button onClick={prev}>Prev</button>
        <button onClick={next}>Next</button>
      </div>
      <Footer />
      </> 
      )
      }
    </div>
  );
}

export default App;
